'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
type MenuButtonProps = {
  label?: string;
  href: string;
  className?: string;
  ariaLabel?: string;
};
export default function MenuButton(t0) {
  const $ = _c(9);
  const {
    label: t1,
    href,
    className,
    ariaLabel
  } = t0;
  const label = t1 === undefined ? "GAME ON" : t1;
  const t2 = ariaLabel ?? label;
  let t3;
  if ($[0] !== label) {
    t3 = <span>{label}</span>;
    $[0] = label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== href || $[3] !== t2 || $[4] !== t3) {
    t4 = <Link href={href} aria-label={t2}>{t3}</Link>;
    $[2] = href;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className || $[7] !== t4) {
    t5 = <StyledWrapper className={className}>{t4}</StyledWrapper>;
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
const StyledWrapper = styled.div`
  & {
    margin-inline: 10px;
  }

  a {
    /* layout */
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    /* sizing like the reference */
    height: 56px;
    padding: 0 40px;

    /* reset link */
    text-decoration: none;
    color: #fff;
    font-family: inherit;

    /* transparent look */
    background: transparent;
    border: none;

    /* feel */
    user-select: none;
    white-space: nowrap;
  }

  /* 4 corner brackets */
  a::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;

    /* corner config */
    --c: #fff;        /* default corner color */
    --c-hover: #803320; /* hover corner color */
    --w: 14px;        /* default arm length */
    --w-hover: 22px;  /* hover arm length */
    --t: 1.5px;       /* thickness */
    --in: 10px;       /* inset */

    background:
        linear-gradient(var(--c), var(--c)) left var(--in) top var(--in) / var(--w) var(--t) no-repeat,
        linear-gradient(var(--c), var(--c)) left var(--in) top var(--in) / var(--t) var(--w) no-repeat,

        linear-gradient(var(--c), var(--c)) right var(--in) top var(--in) / var(--w) var(--t) no-repeat,
        linear-gradient(var(--c), var(--c)) right var(--in) top var(--in) / var(--t) var(--w) no-repeat,

        linear-gradient(var(--c), var(--c)) left var(--in) bottom var(--in) / var(--w) var(--t) no-repeat,
        linear-gradient(var(--c), var(--c)) left var(--in) bottom var(--in) / var(--t) var(--w) no-repeat,

        linear-gradient(var(--c), var(--c)) right var(--in) bottom var(--in) / var(--w) var(--t) no-repeat,
        linear-gradient(var(--c), var(--c)) right var(--in) bottom var(--in) / var(--t) var(--w) no-repeat;

    transition: transform 0.18s linear, background-size 0.18s linear, background-position 0.18s linear, background-color 0.18s linear;
  }

  /* subtle hover like UI reference */
  a:hover::before {
    --c: var(--c-hover);
    --w: var(--w-hover);
  }

  a:hover {
    cursor: pointer;
      color: #fff;
      scale: 1.1;
      animation-duration: 3s;
  }

  span {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.1em;
    position: relative;
    z-index: 1;
  }
`;